import { useEffect } from "react";
import { Layout } from "../../components/Layout";
import { ReservationSearch } from "../../components/ReservationSearch";
import "../../components/Layout/index.css";
import "./searchPage.css";

// Importar fonte Poppins
if (typeof document !== 'undefined') {
  const link = document.createElement('link');
  link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap';
  link.rel = 'stylesheet';
  if (!document.head.querySelector('link[href*="Poppins"]')) {
    document.head.appendChild(link);
  }
}

const SearchPage = () => {
  useEffect(() => {
    // Log de acesso ou outras inicializações
    console.log("SearchPage loaded");
  }, []);

  return (
    <Layout>
      <div className="search-page-container">
        {/* Page Header */}
        <div className="search-page-header">
          <div className="search-page-icon-wrapper">
            <div className="search-page-icon-blur" />
            <div className="search-page-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="8" stroke="white" strokeWidth="2" />
                <path d="M21 21L16.65 16.65" stroke="white" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
          </div>
          <div className="search-page-title-wrapper">
            <h1 className="search-page-title">
              Consultar <span className="search-page-title-gradient">Reserva</span>
            </h1>
            <p className="search-page-subtitle">
              Encontre informações sobre suas reservas usando o código ou telefone cadastrado.
            </p>
          </div>
        </div>

        {/* Search Component */}
        <div className="search-page-content">
          <ReservationSearch />
        </div>
      </div>
    </Layout>
  );
};

export default SearchPage;
